<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="8" :sm="12">
            <a-form-item label="选择渠道">
              <a-select
                v-model="queryParam.channelCode"
                placeholder="请选择渠道"
                style="width: 200px;margin-left: auto"
                @change="handleChange"
              >
                <a-select-option
                  v-for="item in channelList"
                  :key="item.code"
                  :value="item.code"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
              <!-- <a-select v-model="channelKey" placeholder="请选择渠道">
                <a-select-option v-for="(item,index) in channelList" :key="index" >{{item.name}}</a-select-option>
              </a-select> -->
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span
              style="float: left;overflow: hidden;"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAddValue(queryParam.channelCode)"
        >新增分组</a-button
      >
      <a-button @click="refreshClick(queryParam.channelCode)">刷新</a-button>

      <a-button @click="selectClisk">筛选</a-button>

      <a-modal v-model="selVisible" title="筛选" width="920px">
        <template slot="footer">
          <a-button key="back" @click="reactClick">
            重置
          </a-button>
          <a-button key="submit" type="primary" @click="secConfirm">
            搜索
          </a-button>
        </template>
        <a-form layout="inline" ref="searchForm">
          <a-row :gutter="24">
            <a-col :md="8" :sm="8">
              <a-form-item label="分组名称">
                <a-input
                  style="width: 160px;margin-left: auto"
                  placeholder="输入名字模糊查询"
                  v-model="queryParam.groupName"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="8">
              <a-form-item label="分组类型">
                <a-select
                  placeholder="请选择分组类型"
                  style="width: 160px;margin-left: auto"
                  @change="handleChange"
                  v-model="queryParam.groupType"
                >
                  <a-select-option
                    v-for="item in groupType"
                    :key="item.id"
                    :value="item.id"
                    >{{ item.name }}</a-select-option
                  >
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="8">
              <a-form-item label="分组人数">
                <a-input
                  oninput="if(this.value=='00'){this.value='0';}else{this.value=this.value.replace(/[^0-9]/g,'')};"
                  style="width: 70px;margin-left: auto"
                  placeholder="请输入人数范围"
                  v-model="queryParam.countStrart"
                ></a-input>
                <a>~</a>
                <a-input
                  oninput="if(this.value=='00'){this.value='0';}else{this.value=this.value.replace(/[^0-9]/g,'')};"
                  style="width: 70px;margin-left: auto"
                  placeholder="请输入人数范围"
                  v-model="queryParam.countEnd"
                ></a-input>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-modal>
      <!-- <a-popconfirm arrowPointAtCenter  placement="bottom" ok-text="搜索" cancel-text="重置" @cancel="cancel" @confirm="confirm">

        <a-icon slot="icon" type="question-circle-o" style="color: red" />
        <a-button @click="selectClisk" >筛选</a-button>
      </a-popconfirm> -->
      <!-- <a-button @click="selectClisk" >筛选</a-button> -->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"
            ><a-icon type="delete" />删除</a-menu-item
          >
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down"
        /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        :scroll="{ x: 1500 }"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange
        }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="typeslot" slot-scope="text, record">
          <span v-if="record.groupType === 1">动态分组</span>
          <span v-if="record.groupType === 0">静态分组</span>
        </template>

        <template slot="syncslot" slot-scope="text, record">
          <span v-if="record.syncTagFlag === 1">是</span>
          <span v-if="record.syncTagFlag === 0">否</span>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handView(record)">查看</a>
          <a-divider type="vertical" />
          <a @click="handleEdit(record)">修改</a>
          <a-divider type="vertical" />
          <!-- <a @click="Delete(record.id)">删除</a> -->
          <a-dropdown>
            <a class="ant-dropdown-link">删除 <a-icon type="down"/></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm
                  title="确定删除吗?"
                  @confirm="() => handleDelete(record.id)"
                >
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <userConModal ref="modalForm" @ok="handleOk"></userConModal>

    <!-- 查看区域 -->
    <a-modal
      title="查看"
      :visible="viewVisible"
      @cancel="HandleCancel"
      @ok="HandleOk"
      width="1000px"
    >
      <p>分组名称:{{ this.group.groupName }}</p>
      <a-button
        :disabled="userDataListSelections.length == 0"
        @click="exportExcel"
        >批量导出</a-button
      >
      <a-button
        :disabled="userDataListSelections.length == 0"
        @click="handleUserDelete"
        >批量删除</a-button
      >
      <!--微信用户列表-->
      <a-table
        v-if="
          queryParam.channelCode == 'subscribe_wechat' ||
            queryParam.channelCode == 'h5_trade_service'
        "
        ref="table"
        :scroll="{ x: 1500 }"
        size="middle"
        :rowKey="record => record.openid"
        :columns="column"
        :dataSource="userList"
        :row-selection="{
          selectedRowKeys: userDataListSelections,
          onChange: userOnSelectChange
        }"
        class="j-table-force-nowrap"
        :pagination="userPagination"
        @change="userHandleTableChange"
        style="margin-top: 10px"
      >
        <template slot="headimgurlslot" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            <a-avatar
              shape="square"
              :src="getHeadImageView(record.headimgurl)"
              icon="user"
            />
          </div>
        </template>
        <template slot="sexslot" slot-scope="text, record, index">
          <span v-if="record.sex === 1">男</span>
          <span v-if="record.sex === 2">女</span>
          <span v-if="record.sex === 0">未知</span>
        </template>
        <template slot="tagslot" slot-scope="text, record, index">
          <span>{{ getTagName(record.tagidList) }}</span>
        </template>
        <span slot="action" slot-scope="text, record">
          <a-dropdown>
            <a class="ant-dropdown-link">删除 <a-icon type="down"/></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm
                  title="确定删除吗?"
                  @confirm="() => handleUserDelete(record.openid)"
                >
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>

      <!--小程序用户列表-->
      <a-table
        v-if="
          queryParam.channelCode == 'macroscopic_miniapp' ||
            queryParam.channelCode == 'integral_miniapp'
        "
        ref="table"
        :scroll="{ x: 1500 }"
        size="middle"
        :rowKey="record => record.id"
        :columns="columnMiniApp"
        :dataSource="userList"
        :row-selection="{
          selectedRowKeys: userDataListSelections,
          onChange: userOnSelectChange
        }"
        class="j-table-force-nowrap"
        :pagination="userPagination"
        @change="userHandleTableChange"
        style="margin-top: 10px"
      >
        <template slot="headimgurlslot" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            <a-avatar
              shape="square"
              :src="getHeadImageView(record.avatarUrl)"
              icon="user"
            />
          </div>
        </template>
        <template slot="sexslot" slot-scope="text, record, index">
          <span v-if="record.gender === '1.0'">男</span>
          <span v-if="record.gender === '2.0'">女</span>
          <span v-if="record.gender === '0.0'">未知</span>
        </template>
      </a-table>
      <span slot="action" slot-scope="text, record">
        <a-dropdown>
          <a class="ant-dropdown-link">删除 <a-icon type="down"/></a>
          <a-menu slot="overlay">
            <a-menu-item>
              <a-popconfirm
                title="确定删除吗?"
                @confirm="() => handleUserDelete(record.id)"
              >
                <a>删除</a>
              </a-popconfirm>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </a-modal>
    <!-- 分组区域END -->
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less';
import { mixinDevice } from '@/utils/mixin';
import JInput from '@/components/jeecg/JInput';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import userConModal from './modules/app/userConModal';
import {
  getAction,
  postAction,
  getFileAccessHttpUrl,
  downloadFile
} from '@/api/manage';

export default {
  name: 'userConList',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    JInput,
    userConModal
  },
  data() {
    return {
      description: '用户分组管理页面',
      channelList: [],
      group: {},
      channelKey: ' ', //所选择的下标
      isAddWin: false, //新增弹窗是否显示
      selVisible: false,
      viewVisible: false,
      userList: [],
      queryParam: {},
      channelInfo: {},
      userDataListSelections: [],
      userPagination: {
        total: 0,
        pageSize: 4, //每页中显示10条数据
        showSizeChanger: false,
        pageSizeOptions: ['10', '20', '50', '100'], //每页中显示的数据
        showTotal: total => `共有 ${total} 条数据` //分页中显示总的数据
      },
      userPageIndex: 1,
      userPageSize: 4,
      groupType: [
        {
          id: 1,
          name: '动态分组'
        },
        {
          id: 2,
          name: '静态分组'
        }
      ],
      // 表头
      columns: [
        {
          title: '分组ID',
          align: 'center',
          dataIndex: 'id'
        },
        {
          title: '分组名称',
          align: 'center',
          dataIndex: 'groupName'
        },
        {
          title: '分组描述',
          align: 'center',
          dataIndex: 'groupDesc'
        },
        {
          title: '分组类型',
          align: 'center',
          dataIndex: 'groupType',
          scopedSlots: { customRender: 'typeslot' }
        },
        {
          title: '分组人数',
          align: 'center',
          dataIndex: 'count'
        },
        {
          title: '是否同步至标签',
          align: 'center',
          dataIndex: 'syncTagFlag',
          scopedSlots: { customRender: 'syncslot' }
        },

        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: process.env.VUE_APP_CMS_WECHAT + '/wechatGroup/list',
        delete: process.env.VUE_APP_CMS_WECHAT + '/wechatGroup/delete',
        deleteBatch:
          process.env.VUE_APP_CMS_WECHAT + '/wechatGroup/deleteBatch',
        exportXlsUrl: process.env.VUE_APP_CMS_WECHAT + '/wechatUser/exportXls',
        importExcelUrl:
          process.env.VUE_APP_CMS_WECHAT + '/wechatUser/importExcel'
      },
      dictOptions: {},
      column: [
        {
          title: 'openId',
          dataIndex: 'openid',
          align: 'center',
          key: 'openid'
        },
        {
          title: '昵称',
          dataIndex: 'nickname',
          align: 'center',
          key: 'nickname'
        },
        {
          title: '头像',
          dataIndex: 'headimgurl',
          align: 'center',
          key: 'headimgurl',
          width: 120,
          scopedSlots: { customRender: 'headimgurlslot' }
        },
        {
          title: '性别',
          dataIndex: 'sex',
          align: 'center',
          key: 'sex',
          scopedSlots: { customRender: 'sexslot' }
        },
        {
          title: '地区',
          dataIndex: 'city',
          align: 'center',
          key: 'city'
        },
        {
          title: '标签',
          dataIndex: 'tagidList',
          align: 'center',
          key: 'tagidList',
          scopedSlots: { customRender: 'tagslot' }
        },
        {
          title: '关注时间',
          dataIndex: 'subscribeTime',
          align: 'center',
          key: 'subscribeTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' }
        }
      ],
      columnMiniApp: [
        {
          title: 'openId',
          dataIndex: 'openId',
          align: 'center',
          key: 'openId'
        },
        {
          title: '昵称',
          dataIndex: 'nickName',
          align: 'center',
          key: 'nickName'
        },
        {
          title: '头像',
          dataIndex: 'avatarUrl',
          align: 'center',
          key: 'avatarUrl',
          width: 120,
          scopedSlots: { customRender: 'headimgurlslot' }
        },
        {
          title: '性别',
          dataIndex: 'gender',
          align: 'center',
          key: 'gender',
          scopedSlots: { customRender: 'sexslot' }
        },
        {
          title: '地区',
          dataIndex: 'city',
          align: 'center',
          key: 'city'
        },
        {
          title: '手机号',
          dataIndex: 'phone',
          align: 'center',
          key: 'phone'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          align: 'center',
          key: 'createTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' }
        }
      ]
    };
  },
  created() {
    this.getChannelAll();
  },
  computed: {
    importExcelUrl: function() {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
    },
    exportXlsUrl: function() {
      return `${window._CONFIG['domianURL']}/${this.url.exportXlsUrl}`;
    }
  },
  directives: {
    positiveInt: {
      bind: function(el) {
        el.handler = function() {
          el.value = Number(el.value.replace(/\D+/, ''));
        };
        el.addEventListener('input', el.handler);
      },
      unbind: function(el) {
        el.removeEventListener('input', el.handler);
      }
    }
  },
  methods: {
    loadData() {
      /*  this.dataSource = [ {
            "id": "6",
            "groupId": "3",
            "groupName": "测试一下",
            "groupDesc": "测试一下",
            "groupType": 1,
            "delFlag": 0,
            "syncTagFlag": true,
            "channelCode": "subscribe_wechat",
            "count": 8,
            "trendsSql": "select ID from WECHAT_USER_MINIAPP where NICK_NAME='潦草'"
        }]*/
      getAction(this.url.list, this.queryParam).then(res => {
        if (res.success) {
          this.dataSource = res.result;
          console.log('dataSource', this.dataSource);
        }
      });
    },
    getChannelAll() {
      getAction(
        process.env.VUE_APP_CMS_SYSTEM + '/sys/channel/queryAll',
        {}
      ).then(res => {
        if (res.success) {
          this.channelList = res.result;
        }
      });
    },
    //获取渠道信息
    getChannelInfo(item) {
      console.log(item);
      getAction(process.env.VUE_APP_CMS_SYSTEM + '/sys/channel/queryByCode', {
        code: item
      }).then(res => {
        if (res.success) {
          this.channelInfo = res.result;
        }
      });
    },
    handleChange(item) {
      //渠道下拉框选择
      console.log(item);
      this.getChannelInfo(item);
    },
    // handleAdd(){//新增
    //   this.isAddWin = true;
    // },
    refreshClick(channelCode) {
      //刷新按钮点击
      getAction(process.env.VUE_APP_CMS_WECHAT + '/wechatGroup/trendsRefresh', {
        channelCode: channelCode
      }).then(res => {
        if (res.success && res.code === 200) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
      console.log('刷新按钮点击');
    },
    reactClick() {
      //重置
      const channelCode = this.queryParam.channelCode;
      this.searchReset();
      this.queryParam.channelCode = channelCode;
    },
    selectClisk() {
      //筛选按钮点击
      if (!this.queryParam.channelCode) {
        this.$message.warning('请选择渠道');
      } else {
        this.selVisible = true;
      }
    },
    handleOk(res) {
      console.log(res);
    },
    secConfirm() {
      //搜索
      if (this.queryParam.countStrart > this.queryParam.countEnd) {
        this.$message.warning('输入范围有误');
      } else {
        this.loadData();
        this.selVisible = false;
      }
    },
    // Delete(id){
    //   var that = this;
    //   this.$confirm({
    //     title: "确认删除",
    //     content: "是否删除选中数据?",
    //     onOk: function () {
    //       that.handleDelete(id)
    //     }
    //   });
    // },
    handleDelete(id) {
      //删除数据
      console.log(this.url.delete);
      postAction(this.url.delete, { id: id })
        .then(res => {
          if (res.success) {
            this.$message.success(res.message);
            // this.onClearSelected();
          } else {
            this.$message.warning(res.message);
          }
        })
        .finally(() => {
          this.loadData();
        });
    },
    handleUserDelete(id) {
      //删除数据
      if (this.userDataListSelections.length > 0) {
        id = this.userDataListSelections.join(',');
        console.log(id);
      }
      postAction(
        process.env.VUE_APP_CMS_WECHAT + '/wechatGroup/deleteGroupUser',
        { groupId: this.group.id, userIds: id }
      )
        .then(res => {
          if (res.success) {
            this.$message.success(res.message);
            this.viewVisible = false;
          } else {
            this.$message.warning(res.message);
          }
        })
        .finally(() => {});
    },
    // handleEdit(res){
    //   this.isAddWin = true;
    //   console.log('res')
    //   console.log(res)
    // }
    //查看弹框
    handView(record) {
      this.viewVisible = true;
      this.userList = [];
      this.tagListAll = [];
      this.userDataListSelections = [];
      this.group = record;
      if (this.queryParam.channelCode == 'subscribe_wechat') {
        getAction(
          process.env.VUE_APP_CMS_WECHAT + '/manage/wxUserTags/listAll',
          {
            appid: this.channelInfo.linkWechat
          }
        ).then(res => {
          if (res.success && res.code === 200) {
            this.tagListAll = res.result;
          } else {
            this.$message.error(res.message);
          }
        });
      }
      getAction(process.env.VUE_APP_CMS_WECHAT + '/wechatGroup/viewList', {
        id: record.id
      }).then(res => {
        if (res.success & (res.result != null)) {
          console.log(res.result);
          this.userList = res.result.records;
          console.log(this.userList);
        }
      });
    },
    //modal取消
    HandleCancel(e) {
      this.viewVisible = false;
    },
    HandleOk(e) {
      this.viewVisible = false;
    },
    userOnSelectChange(selectedRowKeys) {
      this.userDataListSelections = selectedRowKeys;
      console.log(this.userDataListSelections);
    },
    //获取图片
    getHeadImageView: function(headimgurl) {
      return getFileAccessHttpUrl(headimgurl);
    },
    userHandleTableChange(pagination) {
      const page = { ...this.userPagination };
      this.userPagination.current = pagination.current;
      this.userPagination.pageSize = pagination.pageSize;
      this.userPageIndex = pagination.current;
      this.userPageSize = pagination.pageSize;
      this.userPagination = page;
    },
    //标签名称
    getTagName(tagidList) {
      let userTag = tagidList
        .split('[')[1]
        .split(']')[0]
        .split(',');
      let userTagContent = '';
      for (let i in userTag) {
        for (let j in this.tagListAll) {
          if (userTag[i] == this.tagListAll[j].id) {
            userTagContent += this.tagListAll[j].name + ',';
          }
        }
      }
      if (userTagContent.length > 0) {
        userTagContent = userTagContent.substr(0, userTagContent.length - 1);
      }
      return userTagContent;
    },
    //导出excel
    exportExcel() {
      downloadFile(
        process.env.VUE_APP_CMS_WECHAT + '/wechatUser/exportXls',
        '用户信息.xls',
        {
          type: this.channelInfo.type,
          userIds: this.userDataListSelections.join(',')
        }
      ).then(res => {});
    }
  }
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
